import { AnimatePresence, motion } from 'framer-motion';

import { useOnlineStatus } from '@/stores/useOnlineStatus';

/**
 * Slim banner pinned to the top, only visible when offline. The reconnection
 * toast is fired from useOnlineStatusListener — this is purely the persistent
 * "you're offline" indicator while it's true.
 */
export function OfflineBanner() {
  const online = useOnlineStatus();
  return (
    <AnimatePresence>
      {!online && (
        <motion.div
          initial={{ y: -32, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -32, opacity: 0 }}
          className="fixed inset-x-0 top-0 z-[110] bg-pepper py-1.5 text-center text-xs font-semibold text-white shadow-lg pt-safe"
          role="status"
        >
          ⚡ Hors ligne — affichage de la dernière version connue
        </motion.div>
      )}
    </AnimatePresence>
  );
}
